import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  ST_COURSE_APPLICATION,
  ST_COURSE_APPLICATION_ALL,
  ST_COURSE_APPLICATION_CREATE,
  ST_COURSE_APPLICATION_DELETE,
  ST_COURSE_APPLICATION_FIELD_BATCH,
  ST_COURSE_APPLICATION_FIELD_BATCH_CREATE,
  ST_COURSE_APPLICATION_LIST,
  ST_COURSE_APPLICATION_REQUEST,
  ST_COURSE_APPLICATION_REQUEST_ALL,
  ST_COURSE_APPLICATION_REQUEST_EDIT,
  ST_COURSE_APPLICATION_REQUEST_UPDATE,
  ST_COURSE_APPLICATION_STATUS,
  ST_COURSE_APPLICATION_TYPES,
} from '../constants/actionTypes'

const stCourseApplicationsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const stCourseApplicationSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION]
)

export const stCourseApplicationCreateSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_CREATE]
)

export const stCourseApplicationDeleteSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_DELETE]
)

export const stCourseApplicationRequestSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_REQUEST]
)

export const stCourseApplicationListSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_LIST]
)

export const stCourseApplicationTypesSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_TYPES]
)

export const stCourseApplicationStatusSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_STATUS]
)

export const stCourseApplicationAllSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_ALL]
)
export const stCourseApplicationFieldBatchSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_FIELD_BATCH]
)
export const stCourseApplicationFieldBatchCreateSelector = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_FIELD_BATCH_CREATE]
)

// category
// export const stCourseApplicationCategorySelector = createSelector(
// stCourseApplicationsSelector
//   data => data[]
// )
// export const stCourseApplicationCategoryListSelector = createSelector(
// stCourseApplicationsSelector
//   data => data[]
// )
// export const stCourseApplicationCategoryAllSelector = createSelector(
// stCourseApplicationsSelector
//   data => data[]
// )

// request
export const stCourseApplicationRequestAll = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_REQUEST_ALL]
)
export const stCourseApplicationRequestEdit = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_REQUEST_EDIT]
)

export const stCourseApplicationRequestUpdate = createSelector(
  stCourseApplicationsSelector,
  data => data[ST_COURSE_APPLICATION_REQUEST_UPDATE]
)
